import { AfterViewInit, Component, ElementRef, OnInit, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { DialogBaseComponent } from '../../../shared/dialogs/dialog-base.component';

export interface CreateGroupDialogResults {
  name: string;
  description: string;
}

@Component({
  selector: 'app-create-group-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './create-group-dialog.component.html',
  styleUrl: './create-group-dialog.component.scss'
})
export class CreateGroupDialogComponent extends DialogBaseComponent implements OnInit, AfterViewInit {
  nameInput = viewChild('nameInput', { read: ElementRef });

  private formBuilder = inject(FormBuilder);
  form = this.formBuilder.group({
    name: ['', Validators.required],
    description: ['']
  });

  ngOnInit(): void {
    this.form.patchValue({
      name: this.options.name,
      description: this.options.description
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.nameInput()?.nativeElement.focus();
    });
  }

  onCreateGroup() {
    const results = this.form.value as CreateGroupDialogResults;
    this.complete(results);
  }
}
